import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Mark } from "@/components/Logo";

export function Intro({ onDone }) {
  const [show, setShow] = useState(true);
  const done = useRef(onDone);
  done.current = onDone;
  useEffect(() => {
    const a = setTimeout(() => setShow(false), 1900);
    const b = setTimeout(() => done.current?.(), 2300);
    return () => {
      clearTimeout(a);
      clearTimeout(b);
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-curtain"
          className="fixed inset-0 z-[60] flex items-center justify-center bg-[#0B0B0C]"
          exit={{ clipPath: "inset(0% 0% 100% 0%)" }}
          initial={{ clipPath: "inset(0% 0% 0% 0%)" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex flex-col items-center gap-6 text-[#C6A76A]">
            <Mark className="h-24 w-20" draw />
            <motion.span initial={{ opacity: 0, letterSpacing: "0.2em" }} animate={{ opacity: 1, letterSpacing: "0.6em" }} transition={{ duration: 1.4, delay: 0.5 }} className="font-latin text-[0.7rem] text-[#F7F3EB]/80">
              ATOR RWIHA
            </motion.span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
